import React from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    title: 'BONUS 1',
    subtitle: 'Cómo crear tu Pyme de pisos epoxi',
    desc: 'Formalización, estructura y visión de negocio.',
    image: 'https://cdn.magicpatterns.com/uploads/bMgSJtBUaCDiPVMLaauA1b/WhatsApp_Image_2026-02-15_at_9.36.06_PM.jpg'
  }, {
    id: 2,
    title: 'BONUS 2',
    subtitle: 'Sistema para conseguir clientes todas las semanas',
    desc: 'Estrategia práctica para generar consultas constantes.',
    image: 'https://cdn.magicpatterns.com/uploads/ws7c3pQkT9k5eDvMN71qgp/WhatsApp_Image_2026-02-15_at_9.36.07_PM.jpg'
  }, {
    id: 3,
    title: 'BONUS 3',
    subtitle: 'Mentalidad y posicionamiento de aplicador premium',
    desc: 'Para dejar de competir por precio y cobrar mejor.',
    image: 'https://cdn.magicpatterns.com/uploads/sWzeDwHKMFB8YBS8eHykHR/WhatsApp_Image_2026-02-15_at_9.36.07_PM_(1).jpg'
  }];
  return <section className="py-16 px-4 bg-[#0a0a0a]" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 flex items-center justify-center gap-3" data-id="element-37">
            <Gift className="w-10 h-10 text-amber-500" data-id="element-38" />
            BONOS PARA ACELERAR RESULTADOS
          </h2>
          <p className="text-xl md:text-2xl text-gray-400 font-medium" data-id="element-39">
            No es solo aprender a aplicar. <br data-id="element-40" />
            <span className="font-bold text-amber-400" data-id="element-41">
              Es aprender a facturar.
            </span>
          </p>
        </div>

        <div className="grid gap-12 md:gap-16" data-id="element-42">
          {bonuses.map(bonus => <div key={bonus.id} className="flex flex-col md:flex-row items-center gap-8 bg-[#141414] rounded-2xl p-6 md:p-8 shadow-lg border border-amber-900/30" data-id="element-43">
              <div className="w-full md:w-1/2 cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToPurchase} data-id="element-44">
                <div className="w-full max-w-[420px] mx-auto overflow-hidden rounded-xl shadow-lg shadow-amber-900/20 bg-[#1a1a1a]" data-id="element-45">
                  <img src={bonus.image} alt={bonus.subtitle} className="w-full h-auto object-contain" data-id="element-46" />
                </div>
              </div>

              <div className="w-full md:w-1/2 text-center md:text-left space-y-4" data-id="element-47">
                <span className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-2" data-id="element-48">
                  🎁 GRATIS POR HOY
                </span>
                <h3 className="text-2xl font-bold text-amber-500 uppercase tracking-widest" data-id="element-49">
                  {bonus.title}
                </h3>
                <h4 className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-50">
                  {bonus.subtitle}
                </h4>
                <p className="text-lg text-gray-400" data-id="element-51">{bonus.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-52">
          <p className="text-2xl font-bold text-white bg-amber-900/30 inline-block px-8 py-4 rounded-lg border border-amber-700/40" data-id="element-53">
            🎁 Se entregan junto con tu acceso.
          </p>
        </div>
      </div>
    </section>;
}